import {
  Button,
  ChevronDownIcon,
  Dialog,
  DropdownMenu,
  Flex,
  ExternalLinkIcon,
} from '@buffer-mono/popcorn'

import styles from './Footer.module.css'

import type { JSX } from 'react'

export function Footer(): JSX.Element {
  return (
    <Flex direction="column" align="baseline" className={styles.wrapper}>
      <Dialog.Footer className={styles.footer}>
        <DropdownMenu>
          <DropdownMenu.Trigger>
            <Button
              variant="tertiary"
              size="large"
              className={styles.helpButton}
            >
              Help
              <ChevronDownIcon />
            </Button>
          </DropdownMenu.Trigger>
          <DropdownMenu.Content
            align="start"
            className={styles.dropdownContent}
          >
            <DropdownMenu.Item asChild>
              <a
                className={styles.helpLink}
                href="https://support.buffer.com/articles/getting-instagram-advanced-analytics-and-locations-facebook-authorization-required-acaC8V633l"
                target="_blank"
                rel="noopener noreferrer"
              >
                Troubleshooting and how to link Instagram to a Facebook Page
                <ExternalLinkIcon />
              </a>
            </DropdownMenu.Item>
          </DropdownMenu.Content>
        </DropdownMenu>
      </Dialog.Footer>
    </Flex>
  )
}
